import React, { Fragment } from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import Container from '../../../../../../components/container';
import Box from '../../../../../../components/box';
import { H3, H4, Cols } from '../../../../components';

const QuestionStyled = styled(H4)`
  font-size: 24px !important;
  font-weight: 400 !important;
  // line-height: 2.5 !important;line-height
  letter-spacing: 0.24px !important;
  text-align: left !important;
  text-transform: none !important;

  padding: 6px 0 6px 15px !important;
  cursor: pointer;
`;

const AnswerStyled = styled(H4)`
  text-align: justify;
  padding: 10px 0 10px 15px;
  margin-bottom: 30px;
  font-size: 18px;
  font-weight: normal;
`;

const QuestionBlockStyled = styled(Box)`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;

    ${AnswerStyled} {
      margin-bottom: 0;
    }
  }
`;

const ColsBlockStyled = styled(Box)`
  @media (max-width: 768px) {
    padding-left: 0 !important;
  }
`;

class QuestionBlock extends React.Component {
  state = {isOpened: false}

  render() {
    const question = this.props.question || this.props.q;
    const answer = this.props.answer || this.props.a;

    if (!question || !answer) {
      return null;
    }

    return (
      <QuestionBlockStyled>
        <QuestionStyled
          className={clsx({'mb-0': this.state.isOpened})}
          onClick={() => {
            this.setState(({isOpened}) => ({isOpened: !isOpened}))
          }}
        >{question}</QuestionStyled>

        {this.state.isOpened && (
          <AnswerStyled component="div" upperCase={false} lineBlue dangerouslySetInnerHTML={{__html: answer}} />
        )}
      </QuestionBlockStyled>
    )
  }
}

const QuestionsSection = ({title, questions = [], ...rest}) => {
  const halfLength = Math.ceil(questions.length / 2);
  const items = [
    <Fragment>
      {questions.slice(0, halfLength).map((item, index) => (<QuestionBlock key={index} {...item} />))}
    </Fragment>,

    <Fragment>
      {questions.slice(halfLength, questions.length).map((item, index) => (<QuestionBlock key={index} {...item} />))}
    </Fragment>
  ].map(item => ({descriptionProps: {mt: 0, mb: 1}, description: item}));


  return (
    <Container {...rest}>
      <H3>{title}</H3>

      <ColsBlockStyled pl={6}>
        <Cols items={items} itemXsMb={0} />
      </ColsBlockStyled>
    </Container>
  )
}

QuestionsSection.defaultProps = {
  title: 'Questions les plus fréquentes :',
};

export default QuestionsSection;